export * from './properties.keys';
export * from './useGetPropertiesQuery';
